var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1668 11.4287H13.8335C12.7815 11.4287 11.9287 12.2815 11.9287 13.3335V26.6668C11.9287 27.7188 12.7815 28.5716 13.8335 28.5716H27.1668C28.2188 28.5716 29.0716 27.7188 29.0716 26.6668V13.3335C29.0716 12.2815 28.2188 11.4287 27.1668 11.4287Z",
    stroke: "#8E8E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1669 18.0954C17.9558 18.0954 18.5954 17.4558 18.5954 16.6669C18.5954 15.8779 17.9558 15.2383 17.1669 15.2383C16.3779 15.2383 15.7383 15.8779 15.7383 16.6669C15.7383 17.4558 16.3779 18.0954 17.1669 18.0954Z",
    stroke: "#8E8E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0716 22.8571L24.3097 18.0952L13.8335 28.5714",
    stroke: "#8E8E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftImagePlaceholder);
export default __webpack_public_path__ + "static/media/nftImagePlaceholder.2366eef8d9b6b36998ddd5aa00fb2cd5.svg";
export { ForwardRef as ReactComponent };